import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Calendar, ArrowRight } from 'lucide-react';

const PLACEHOLDER_COLUMNS = ['Date', 'Service', 'Customer', 'Source', 'Status', 'Amount'];

export default function ServiceBookings() {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <h1 className="text-3xl font-bold">Service Bookings</h1>
        <Badge variant="secondary">Coming soon</Badge>
      </div>
      <p className="text-muted-foreground">
        Track bookings, appointments, and reservations across all your services.
      </p>

      {/* Empty State */}
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-16 text-center">
          <Calendar className="w-12 h-12 text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold mb-2">No bookings yet</h3>
          <p className="text-muted-foreground max-w-md mb-6">
            Bookings will appear here once a booking system is connected.
            Connect Calendly, TripAdvisor, or other booking platforms from the Integrations page.
          </p>
          <Button onClick={() => navigate('/service/integrations')}>
            <ArrowRight className="w-4 h-4 mr-2" />
            Go to Integrations
          </Button>
        </CardContent>
      </Card>

      {/* Placeholder Table */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Recent Bookings</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                {PLACEHOLDER_COLUMNS.map((col) => (
                  <TableHead key={col}>{col}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell colSpan={PLACEHOLDER_COLUMNS.length} className="text-center text-muted-foreground py-8">
                  No booking data available. Connect a booking integration to start tracking.
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
